<template src="./Footer.html"></template>

<script>
export default {
  name: "Footer"
};
</script>

<style src="./Footer.scss" lang="scss"></style>
